import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBanner } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { t } from 'ember-intl';

export default class SettingsCentralMappingBannerCostProfilesEmpty extends Component<object> {
  @service declare centralMapping: Services['central-mapping'];
  @service declare intl: Services['intl'];

  get bannerPrimaryAction(): {
    action: () => void;
    iconAfter: IconName;
    label: string;
  } {
    return {
      label: this.intl.t('general.go_to_settings'),
      action: (): void => this.centralMapping.openCostSettings(),
      iconAfter: 'link-out',
    };
  }

  <template>
    <div data-test-id="cost-profiles-empty-banner" role="status">
      <PrismBanner
        @bannerMessage={{t "settings.central_mapping.mapping.cost_empty"}}
        @bannerStyle="info"
        @hasCta={{true}}
        @icon="circle-information-outline"
        @isOneLine={{true}}
        @position="island"
        @primaryAction={{this.bannerPrimaryAction}}
      />
    </div>
  </template>
}
